import { BaseDateExpression } from "./BaseDateExpression";
import { ExecutionData } from "../../../Common/Data/ExecutionData/ExecutionData";
import { ITestingContext } from "../../../Common/Testing/ITestingContext";
import type { AppGlueAny } from "../../../Common/AppGlueAny";

export class DateNowExpression extends BaseDateExpression {
    readonly __type: string = "Now";

    evaluate(_data: ExecutionData, _testContext: ITestingContext | undefined): AppGlueAny {
        return Date.now();
    }
}
